import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Package, Save } from "lucide-react";

export default function SuperAdminBusinessTypes() {
  const [types, setTypes] = useState([]);
  const [edits, setEdits] = useState({});
  const [saving, setSaving] = useState({});

  const load = async () => {
    try {
      const r = await api.get("/business-types");
      setTypes(r.data);
      const init = {};
      r.data.forEach(t => { init[t.code] = t.label; });
      setEdits(init);
    } catch(e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const save = async (code) => {
    const label = (edits[code] || "").trim();
    if (!label) { toast.error("Label tidak boleh kosong"); return; }
    setSaving({...saving, [code]: true});
    try {
      await api.put(`/business-types/${code}`, { label });
      toast.success("Label berhasil diubah");
      load();
    } catch(e) { toast.error(formatApiError(e)); }
    finally { setSaving({...saving, [code]: false}); }
  };

  return (
    <>
      <PageHeader
        title="Jenis Bisnis"
        subtitle="Kelola label jenis bisnis yang muncul di seluruh sistem. Kode internal tidak bisa diubah untuk menjaga integritas data."
      />
      <div className="max-w-3xl space-y-3" data-testid="business-types-page">
        {types.map(t => (
          <div key={t.code}
            className="bg-white border rounded-sm p-5 flex items-center gap-4"
            data-enter-scope
            data-testid={`biz-type-row-${t.code}`}>
            <div className="w-11 h-11 rounded-md bg-slate-100 flex items-center justify-center text-slate-500">
              <Package size={20}/>
            </div>
            <div className="flex-1 grid gap-2">
              <div className="text-[11px] uppercase tracking-wider text-slate-400 font-medium">Kode: {t.code}</div>
              <Label>Label Tampilan</Label>
              <Input
                data-testid={`biz-type-input-${t.code}`}
                value={edits[t.code] || ""}
                onChange={(e)=>setEdits({...edits, [t.code]: e.target.value})}
                placeholder="Masukkan label..."
              />
              {t.features_produksi && (
                <div className="text-xs text-emerald-600">✓ Modul Produksi & HPP aktif untuk jenis ini</div>
              )}
            </div>
            <Button
              onClick={()=>save(t.code)}
              disabled={saving[t.code] || (edits[t.code] || "").trim() === t.label}
              className="brand-btn"
              data-enter-submit
              data-testid={`biz-type-save-${t.code}`}
            >
              <Save size={14} className="mr-1"/> Simpan
            </Button>
          </div>
        ))}
        {types.length === 0 && (
          <div className="text-sm text-slate-500 py-8 text-center">Memuat...</div>
        )}
      </div>
    </>
  );
}
